'use client';

import React, { useState } from "react";
import styles from "./FaqComponent.module.css";

interface FaqItem {
  id?: string | number;
  questionTitle: string;
  description: string;
}

interface FaqComponentProps {
  faqs: FaqItem[];
}

// تابع برای حذف تکرار کلمه "هتل" (مثلاً "هتل هتل ارم" می‌شود "هتل ارم")
const cleanDuplicateHotel = (text: string) => {
  if (!text) return text;
  // این عبارت منظم هر جا کلمه هتل پشت سر هم بیاید را با یک هتل جایگزین می‌کند
  return text.replace(/هتل(?:\s+هتل)+/g, 'هتل');
};

const FaqComponent: React.FC<FaqComponentProps> = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0); // به‌صورت پیش‌فرض آیتم اول باز باشد (مثل تصویر)

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles.section} dir="rtl" aria-label="پرسش‌های متداول">
      <h2 className={styles.title}>سؤالات متداول</h2>

      {faqs && faqs.length > 0 ? (
        <div className={styles.accordionCard}>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            // اعمال تابع پاکسازی روی تایتل و توضیحات
            const cleanedTitle = cleanDuplicateHotel(faq.questionTitle);
            const cleanedDescription = cleanDuplicateHotel(faq.description);

            return (
              <div
                key={faq.id ?? index}
                className={`${styles.faqItem} ${isOpen ? styles.active : ""}`}
              >
                {/* هدر آکاردئون */}
                <div
                  className={styles.header}
                  onClick={() => toggleAccordion(index)}
                >
                  <div className={styles.questionWrapper}>
                    {/* آیکون فایل سوال */}
                    <div className={styles.docIcon}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#58a01f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <path d="M12 17v-4"></path>
                        <path d="M12 10h.01"></path>
                      </svg>
                    </div>
                    {/* نمایش تایتل اصلاح شده */}
                    <h3 className={styles.questionText}>{cleanedTitle}</h3>
                  </div>

                  {/* آیکون باز و بسته شدن (چپ) */}
                  <div className={styles.toggleIcon}>
                    {isOpen ? (
                      // دایره سبز با فلش رو به بالا (حالت باز)
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="11" fill="#7cb342" />
                        <path d="M16 14L12 10L8 14" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      // دایره طوسی با فلش رو به پایین (حالت بسته)
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="11" fill="#e2e8f0" />
                        <path d="M8 10L12 14L16 10" stroke="#475569" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </div>
                </div>

                {/* بدنه آکاردئون (توضیحات) */}
                <div
                  className={styles.body}
                  style={{ maxHeight: isOpen ? "500px" : "0" }} // انیمیشن باز و بسته شدن
                >
                  <div
                    className={styles.bodyContent}
                    // نمایش توضیحات اصلاح شده
                    dangerouslySetInnerHTML={{ __html: cleanedDescription }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={styles.emptyAlert}>
          سوالات پرتکرار موجود نمی‌باشد.
        </div>
      )}
    </section>
  );
};

export default FaqComponent;
